import ConfPage from "./components/ConfPage";

export default {
    icon: 'cog',
    url: 'conf',
    name: 'Configurações',
    routes: [
        {
            path: '/conf',
            name: 'conf',
            component: ConfPage
        },
    ]
}